import {Component, OnDestroy, OnInit} from '@angular/core';
import {FiltroListagemContrato} from './dto/filtroListagemContrato';
import {ResultadoFiltragemContrato} from './dto/resultadoFiltragemContrato';
import {Subscription} from 'rxjs';
import {ContratoService} from '../contratoService';
import {LoadingService} from '../../../services/loading.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-contrato-by-numerocontrato',
  templateUrl: './contrato-by-numerocontrato.component.html',
  styleUrls: ['./contrato-by-numerocontrato.component.scss']
})
export class ContratoByNumerocontratoComponent implements OnInit, OnDestroy {

  resultadoFiltragemContrato: ResultadoFiltragemContrato;

  filtroListagemContrato = new FiltroListagemContrato();

  private subscriptions: Subscription[] = [];

  constructor(private contratoService: ContratoService,
              private loadingService: LoadingService,
              private route: ActivatedRoute
  ) {

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnInit() {
    this.initContrato();
  }

  private initContrato() {
    this.loadingService.changeLoading(true);

    this.filtroListagemContrato.numero_contrato = this.getNumeroContrato();

    this.search();
  }

  private getNumeroContrato() {
    const numeroContrato = this.route.snapshot.paramMap.get('numero_contrato');

    return numeroContrato;
  }

  private search() {
    this.loadingService.changeLoading(true);
    const subscription = this.contratoService
      .getContratosByFilter(this.filtroListagemContrato)
      .subscribe(resultados => {
        this.resultadoFiltragemContrato = resultados;
        this.loadingService.changeLoading(false);
        console.log(resultados);
      }, error => {
        this.loadingService.changeLoading(false);
      });
    this.subscriptions.push(subscription);
  }

  download(contratoUri: string) {
    window.open(contratoUri);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contrato/contrato-by-numerocontrato/contrato-by-numerocontrato.component.ts